import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import style from './customer-auto-complete.module.less';
import { emptyArray } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

/**
 * The main purpose of this event handler is to mitigate an issue with the `GlobalEventListenerRoot` (GELR).
 * The GELR hijacks the focus from the element where the event originates. Because of this, we're unable
 * to observe the "relatedTarget" on the blur event for the input. This means that the results
 * were being cleared in the blur event before the click event in the result could be fired. By swallowing the
 * `mouseDown` event here, we prevent the blur event from being fired altogether.
 * @param {object} event triggered by the mouseDown event
 * @returns {void}
 */
const preventMouseDownBlur = (event) => event.preventDefault();

/**
 * @param {object} props
 * @param {string} props.name
 * @param {string} props.city
 * @param {string} props.state
 * @param {(index: number, path: string) => void} props.onRowClick
 * @param {number} props.index
 * @param {string} props.path
 * @returns {JSX.Element}
 */
const CustomerRow = ({ name = '', city = '', state = '', onRowClick, index, path = '' }) => (
  <DropdownMenuItem className={style.row} onClick={() => onRowClick(index, path)}>
    {name}
    <span className={style['row-location']}>
      ({city}, {state})
    </span>
  </DropdownMenuItem>
);

/**
 * @typedef {object} Customer
 * @property {string} name
 * @property {string} city
 * @property {string} state
 */

/**
 * @param {object} props
 * @param {Customer[]} props.customers
 * @param {(index: number, path: string) => void} props.onRowClick
 * @param {string} props.path
 * @returns {JSX.Element}
 */
export const CustomerAutoComplete = ({ customers = emptyArray, onRowClick = noop, path = '' }) => (
  <div className={style.container} onMouseDown={preventMouseDownBlur}>
    {(customers ?? []).map((customer, idx) => (
      <CustomerRow
        key={idx}
        city={customer.city}
        index={idx}
        name={customer.name}
        onRowClick={onRowClick}
        path={path}
        state={customer.state}
      />
    ))}
  </div>
);
